import { useRef, useEffect } from 'react';
import { Pressable, Text, StyleSheet, Platform } from 'react-native';
import { theme } from '@/constants/theme';

export function SkipToContent() {
  const skipLinkRef = useRef<any>(null);

  // ווב בלבד - להעביר פוקוס לתוכן הראשי
  const skipToMainContent = () => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;

    const mainContent = window.document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // ווב בלבד - קיצור מקלדת (Alt + 1)
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.altKey && e.key === '1') {
        e.preventDefault();
        skipToMainContent();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // רק בווב
  if (Platform.OS !== 'web') return null;

  return (
    <Pressable
      ref={skipLinkRef}
      style={({ focused }) => [
        styles.skipLink,
        focused && styles.skipLinkFocused,
      ]}
      onPress={skipToMainContent}
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel="דלג לתוכן הראשי"
      accessibilityHint="לחץ Enter או Alt+1 לדלג ישירות לתוכן הראשי של העמוד"
    >
      <Text style={styles.skipLinkText}>דלג לתוכן הראשי (Alt + 1)</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  skipLink: {
    position: 'absolute',
    top: -100,
    left: '50%',
    transform: [{ translateX: -150 }],
    backgroundColor: theme.colors.primary,
    paddingVertical: theme.spacing.md,
    paddingHorizontal: theme.spacing.lg,
    borderRadius: theme.borderRadius.md,
    zIndex: 9999,
    ...(Platform.OS === 'web' && {
      outlineWidth: 0,
    }),
  } as any,
  skipLinkFocused: {
    top: theme.spacing.md,
    ...(Platform.OS === 'web' && {
      boxShadow: '0 4px 20px rgba(142, 95, 255, 0.6)',
      outlineColor: '#FFFFFF',
      outlineStyle: 'solid',
      outlineWidth: '3px',
      outlineOffset: '2px',
    }),
  } as any,
  skipLinkText: {
    fontSize: 16,
    fontFamily: theme.fonts.bold,
    color: '#FFFFFF',
    textAlign: 'center',
  },
});
